/**
 * 区域代理后台
 * 代理查看团队业绩、管理奖、提现等
 */
import { useState, useEffect } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE

export default function AgentCenter() {
  const [phone, setPhone] = useState('')
  const [password, setPassword] = useState('')
  const [agent, setAgent] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [tab, setTab] = useState('overview')
  const [stats, setStats] = useState(null)
  const [downlines, setDownlines] = useState([])
  const [commissions, setCommissions] = useState([])
  const [showWithdraw, setShowWithdraw] = useState(false)
  const [withdrawAmount, setWithdrawAmount] = useState('')
  const [withdrawLoading, setWithdrawLoading] = useState(false)

  // 代理级别配置
  const levelConfig = {
    province: { name: '省级代理', color: '#722ed1', manageRate: '10%', recommendBonus: '一级40%+二级10%' },
    city: { name: '市级代理', color: '#fa8c16', manageRate: '8%', recommendBonus: '一级30%+二级10%' },
    county: { name: '县级代理', color: '#13c2c2', manageRate: '5%', recommendBonus: '一级20%' }
  }

  // 登录
  const handleLogin = async () => {
    if (!phone.trim()) { setError('请输入手机号'); return }
    if (!password) { setError('请输入密码'); return }
    
    setLoading(true)
    setError('')
    try {
      const res = await fetch(`${API}/regional-agents/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phone: phone.trim(), password })
      })
      const d = await res.json()
      if (d.success) {
        setAgent(d.data.agent)
        loadStats(d.data.agent.id)
        loadDownlines(d.data.agent.id)
        loadCommissions(d.data.agent.id)
      } else {
        setError(d.error || '登录失败')
      }
    } catch (e) {
      setError('登录失败')
    }
    setLoading(false)
  }

  // 加载统计数据
  const loadStats = async (agentId) => {
    try {
      const res = await fetch(`${API}/regional-agents/${agentId}/stats`)
      const d = await res.json()
      if (d.success) {
        setStats(d.data)
      }
    } catch (e) { console.error(e) }
  }

  // 加载下线列表
  const loadDownlines = async (agentId) => {
    try {
      const res = await fetch(`${API}/regional-agents/${agentId}/downlines`)
      const d = await res.json()
      if (d.success) {
        setDownlines(d.data || [])
      }
    } catch (e) { console.error(e) }
  }

  // 加载佣金记录
  const loadCommissions = async (agentId) => {
    try {
      const res = await fetch(`${API}/regional-agents/${agentId}/commissions`)
      const d = await res.json()
      if (d.success) {
        setCommissions(d.data || [])
      }
    } catch (e) { console.error(e) }
  }

  // 申请提现
  const handleWithdraw = async () => {
    if (!withdrawAmount || parseFloat(withdrawAmount) < 100) {
      alert('最低提现金额100元')
      return
    }
    
    setWithdrawLoading(true)
    try {
      const res = await fetch(`${API}/regional-agents/withdraw`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          agent_id: agent.id,
          amount: parseFloat(withdrawAmount)
        })
      })
      const d = await res.json()
      if (d.success) {
        alert('提现申请已提交')
        setShowWithdraw(false)
        setWithdrawAmount('')
        loadStats(agent.id)
      } else {
        alert(d.error || '提现失败')
      }
    } catch (e) {
      alert('提现失败')
    }
    setWithdrawLoading(false)
  }

  // 退出登录
  const handleLogout = () => {
    setAgent(null)
    setStats(null)
    setDownlines([])
    setCommissions([])
    setPhone('')
    setPassword('')
  }

  // 格式化金额
  const formatMoney = (amount) => {
    return amount ? '¥' + parseFloat(amount).toFixed(2) : '¥0.00'
  }

  // 未登录界面
  if (!agent) {
    return (
      <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', padding: '40px 20px' }}>
        <div style={{ maxWidth: 400, margin: '0 auto', background: '#fff', borderRadius: 16, padding: 32 }}>
          <div style={{ textAlign: 'center', marginBottom: 32 }}>
            <h2 style={{ fontSize: 24, marginBottom: 8 }}>🌐 区域代理后台</h2>
            <p style={{ color: '#666' }}>登录查看团队业绩和管理奖</p>
          </div>
          
          {error && (
            <div style={{ background: '#fff1f0', color: '#cf1322', padding: 12, borderRadius: 8, marginBottom: 16, textAlign: 'center' }}>
              {error}
            </div>
          )}
          
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', marginBottom: 6, color: '#666' }}>手机号</label>
            <input
              type="tel"
              value={phone}
              onChange={e => setPhone(e.target.value)}
              placeholder="请输入手机号"
              maxLength={11}
              style={{ width: '100%', padding: 12, border: '1px solid #d9d9d9', borderRadius: 8, fontSize: 16, boxSizing: 'border-box' }}
            />
          </div>
          
          <div style={{ marginBottom: 24 }}>
            <label style={{ display: 'block', marginBottom: 6, color: '#666' }}>密码</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="请输入密码"
              style={{ width: '100%', padding: 12, border: '1px solid #d9d9d9', borderRadius: 8, fontSize: 16, boxSizing: 'border-box' }}
            />
          </div>
          
          <button
            onClick={handleLogin}
            disabled={loading}
            style={{ width: '100%', padding: 14, background: loading ? '#d9d9d9' : '#667eea', color: '#fff', border: 'none', borderRadius: 8, fontSize: 16, cursor: loading ? 'not-allowed' : 'pointer' }}
          >
            {loading ? '登录中...' : '登录'}
          </button>
          
          <div style={{ marginTop: 24, textAlign: 'center', fontSize: 13, color: '#999' }}>
            <p>还不是代理？<a href="/?page=regional-agent-register" style={{ color: '#667eea' }}>立即申请</a></p>
          </div>
        </div>
      </div>
    )
  }

  const config = levelConfig[agent.region_level] || levelConfig.county

  return (
    <div style={{ minHeight: '100vh', background: '#f0f2f5' }}>
      {/* 顶部导航 */}
      <div style={{ background: '#001529', color: '#fff', padding: '16px 20px', position: 'sticky', top: 0, zIndex: 100 }}>
        <div style={{ maxWidth: 1200, margin: '0 auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <h3 style={{ margin: 0 }}>🌐 区域代理后台</h3>
            <div style={{ fontSize: 12, opacity: 0.8, marginTop: 4 }}>
              {agent.name} · {config.name}
            </div>
          </div>
          <button onClick={handleLogout} style={{ padding: '8px 16px', background: 'rgba(255,255,255,0.2)', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' }}>
            退出
          </button>
        </div>
      </div>

      <div style={{ maxWidth: 1200, margin: '0 auto', padding: 20 }}>
        {/* 概览卡片 */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 24 }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 20, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
            <div style={{ fontSize: 13, color: '#666', marginBottom: 8 }}>账户余额</div>
            <div style={{ fontSize: 28, fontWeight: 'bold', color: config.color }}>
              {formatMoney(stats?.available_balance)}
            </div>
          </div>
          <div style={{ background: '#fff', borderRadius: 12, padding: 20, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
            <div style={{ fontSize: 13, color: '#666', marginBottom: 8 }}>累计收益</div>
            <div style={{ fontSize: 28, fontWeight: 'bold', color: '#52c41a' }}>
              {formatMoney(stats?.total_earned)}
            </div>
          </div>
          <div style={{ background: '#fff', borderRadius: 12, padding: 20, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
            <div style={{ fontSize: 13, color: '#666', marginBottom: 8 }}>下线数量</div>
            <div style={{ fontSize: 28, fontWeight: 'bold', color: '#1890ff' }}>
              {downlines.length}
            </div>
          </div>
          <div style={{ background: '#fff', borderRadius: 12, padding: 20, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
            <div style={{ fontSize: 13, color: '#666', marginBottom: 8 }}>管理奖比例</div>
            <div style={{ fontSize: 28, fontWeight: 'bold', color: '#fa8c16' }}>
              {config.manageRate}
            </div>
          </div>
        </div>

        {/* Tab导航 */}
        <div style={{ background: '#fff', borderRadius: 12, marginBottom: 20, overflow: 'hidden' }}>
          <div style={{ display: 'flex', borderBottom: '1px solid #f0f0f0' }}>
            {['overview', 'downlines', 'commissions'].map(t => (
              <div
                key={t}
                onClick={() => setTab(t)}
                style={{
                  flex: 1,
                  padding: '14px',
                  textAlign: 'center',
                  cursor: 'pointer',
                  borderBottom: tab === t ? `2px solid ${config.color}` : '2px solid transparent',
                  color: tab === t ? config.color : '#666',
                  fontWeight: tab === t ? 600 : 400
                }}
              >
                {t === 'overview' ? '📊 业绩概览' : t === 'downlines' ? '👥 下线管理' : '💰 佣金记录'}
              </div>
            ))}
          </div>

          <div style={{ padding: 20 }}>
            {/* 业绩概览 */}
            {tab === 'overview' && (
              <div>
                <h4 style={{ margin: '0 0 16px' }}>收益明细</h4>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 16 }}>
                  <div style={{ background: '#f6ffed', padding: 16, borderRadius: 8 }}>
                    <div style={{ fontSize: 13, color: '#52c41a' }}>推荐奖收入</div>
                    <div style={{ fontSize: 24, fontWeight: 'bold', marginTop: 8 }}>
                      {formatMoney(stats?.recommend_bonus)}
                    </div>
                  </div>
                  <div style={{ background: '#e6f7ff', padding: 16, borderRadius: 8 }}>
                    <div style={{ fontSize: 13, color: '#1890ff' }}>管理奖收入</div>
                    <div style={{ fontSize: 24, fontWeight: 'bold', marginTop: 8 }}>
                      {formatMoney(stats?.management_bonus)}
                    </div>
                  </div>
                  <div style={{ background: '#fff7e6', padding: 16, borderRadius: 8 }}>
                    <div style={{ fontSize: 13, color: '#fa8c16' }}>已提现</div>
                    <div style={{ fontSize: 24, fontWeight: 'bold', marginTop: 8 }}>
                      {formatMoney(stats?.total_withdrawn)}
                    </div>
                  </div>
                  <div style={{ background: '#f9f0ff', padding: 16, borderRadius: 8 }}>
                    <div style={{ fontSize: 13, color: '#722ed1' }}>代理区域</div>
                    <div style={{ fontSize: 20, fontWeight: 'bold', marginTop: 8 }}>
                      {agent.region_name}
                    </div>
                  </div>
                </div>
                
                <button
                  onClick={() => setShowWithdraw(true)}
                  disabled={!stats || parseFloat(stats.available_balance || 0) < 100}
                  style={{
                    marginTop: 24,
                    width: '100%',
                    padding: 14,
                    background: stats && parseFloat(stats.available_balance || 0) >= 100 ? '#52c41a' : '#d9d9d9',
                    color: '#fff',
                    border: 'none',
                    borderRadius: 8,
                    fontSize: 16,
                    cursor: stats && parseFloat(stats.available_balance || 0) >= 100 ? 'pointer' : 'not-allowed'
                  }}
                >
                  申请提现（最低100元）
                </button>
              </div>
            )}

            {/* 下线管理 */}
            {tab === 'downlines' && (
              <div>
                <h4 style={{ margin: '0 0 16px' }}>下线列表（{downlines.length}人）</h4>
                {downlines.length === 0 ? (
                  <div style={{ textAlign: 'center', padding: 40, color: '#999' }}>
                    暂无下线，继续推广招募吧！
                  </div>
                ) : (
                  <div style={{ border: '1px solid #f0f0f0', borderRadius: 8 }}>
                    {downlines.map((d, i) => (
                      <div key={i} style={{ padding: 16, borderBottom: i < downlines.length - 1 ? '1px solid #f0f0f0' : 'none' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                          <div>
                            <div style={{ fontWeight: 500 }}>{d.name}</div>
                            <div style={{ fontSize: 12, color: '#999', marginTop: 4 }}>{d.phone}</div>
                          </div>
                          <div style={{ textAlign: 'right' }}>
                            <div style={{ color: config.color, fontWeight: 500 }}>
                              {d.promo_type === 'certified' ? '认证推广员' : d.promo_type === 'agency' ? '机构推广合伙人' : '个人推广员'}
                            </div>
                            <div style={{ fontSize: 12, color: '#999', marginTop: 4 }}>
                              注册于 {d.created_at?.split('T')[0]}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}

            {/* 佣金记录 */}
            {tab === 'commissions' && (
              <div>
                <h4 style={{ margin: '0 0 16px' }}>佣金记录</h4>
                {commissions.length === 0 ? (
                  <div style={{ textAlign: 'center', padding: 40, color: '#999' }}>
                    暂无佣金记录
                  </div>
                ) : (
                  <div style={{ border: '1px solid #f0f0f0', borderRadius: 8 }}>
                    {commissions.map((c, i) => (
                      <div key={i} style={{ padding: 16, borderBottom: i < commissions.length - 1 ? '1px solid #f0f0f0' : 'none' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <div>
                            <div style={{ fontWeight: 500 }}>
                              {c.type === 'recommend_bonus' ? '推荐奖' : c.type === 'agent_management_bonus' ? '管理奖' : '其他'}
                            </div>
                            <div style={{ fontSize: 12, color: '#999', marginTop: 4 }}>
                              {c.remark} · {c.created_at?.split('T')[0]}
                            </div>
                          </div>
                          <div style={{ color: '#52c41a', fontWeight: 'bold', fontSize: 16 }}>
                            +{formatMoney(c.amount)}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* 提现弹窗 */}
      {showWithdraw && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          background: 'rgba(0,0,0,0.5)', zIndex: 1000,
          display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}>
          <div style={{ background: '#fff', borderRadius: 16, padding: 32, width: 350, textAlign: 'center' }}>
            <h3 style={{ margin: '0 0 24px' }}>申请提现</h3>
            <div style={{ marginBottom: 16 }}>
              <input
                type="number"
                value={withdrawAmount}
                onChange={e => setWithdrawAmount(e.target.value)}
                placeholder="请输入提现金额"
                style={{ width: '100%', padding: 12, border: '1px solid #d9d9d9', borderRadius: 8, fontSize: 16, textAlign: 'center' }}
              />
            </div>
            <div style={{ fontSize: 13, color: '#999', marginBottom: 24 }}>
              可提现余额：{formatMoney(stats?.available_balance)}
            </div>
            <div style={{ display: 'flex', gap: 12 }}>
              <button
                onClick={() => setShowWithdraw(false)}
                style={{ flex: 1, padding: 12, background: '#f5f5f5', border: 'none', borderRadius: 8, cursor: 'pointer' }}
              >
                取消
              </button>
              <button
                onClick={handleWithdraw}
                disabled={withdrawLoading}
                style={{ flex: 1, padding: 12, background: '#52c41a', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer' }}
              >
                {withdrawLoading ? '提交中...' : '确认提现'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
